var map = {
	"./SushiSwap.png": 7877,
	"./bitmart.png": 9748,
	"./comp1.png": 6753,
	"./comp2.png": 2931,
	"./comp3.jpg": 3576,
	"./comp4.png": 5013,
	"./cont1.png": 2797,
	"./cont10_bg.png": 2149,
	"./cont12_img1.png": 1754,
	"./cont12_img2.png": 3760,
	"./cont12_img3.png": 9311,
	"./cont12_img4.png": 4241,
	"./cont12_img5.png": 1853,
	"./cont12_img6.png": 2702,
	"./cont12_img7.png": 7153,
	"./cont13_bg1.jpg": 4149,
	"./cont13_bg1.png": 7094,
	"./cont13_bg10.jpg": 6657,
	"./cont13_bg11.jpg": 8985,
	"./cont13_bg12.jpg": 4396,
	"./cont13_bg13.jpg": 8848,
	"./cont13_bg14.jpg": 1670,
	"./cont13_bg15.jpg": 6902,
	"./cont13_bg16.jpg": 1477,
	"./cont13_bg17.jpg": 3811,
	"./cont13_bg18.jpg": 4553,
	"./cont13_bg19.jpg": 1193,
	"./cont13_bg2.png": 5713,
	"./cont13_bg20.jpg": 1722,
	"./cont13_bg21.jpg": 104,
	"./cont13_bg22.jpg": 5499,
	"./cont13_bg23.jpg": 9846,
	"./cont13_bg24.jpg": 422,
	"./cont13_bg25.jpg": 8481,
	"./cont13_bg26.jpg": 8536,
	"./cont13_bg27.jpg": 9474,
	"./cont13_bg28.jpg": 5521,
	"./cont13_bg29.jpg": 885,
	"./cont13_bg3.png": 2205,
	"./cont13_bg30.jpg": 2503,
	"./cont13_bg4.png": 1681,
	"./cont13_bg5.png": 6972,
	"./cont13_bg6.png": 9216,
	"./cont13_bg7.png": 2807,
	"./cont13_bg8.png": 2894,
	"./cont13_bg9.jpg": 7325,
	"./cont3_bg.png": 4752,
	"./cont3_icon1.png": 5800,
	"./cont3_icon2.png": 3688,
	"./cont3_icon3.png": 9075,
	"./cont3_icon4.png": 1442,
	"./cont3_icon5.png": 1603,
	"./cont3_icon6.png": 7227,
	"./cont3_img1.png": 342,
	"./cont3_img4.svg": 1842,
	"./cont3_img5.jpg": 8377,
	"./cont3_img9.png": 729,
	"./cont4_bg1.jpg": 7439,
	"./cont4_bg1.png": 7579,
	"./cont4_bg2.jpg": 9011,
	"./cont4_bg2.png": 469,
	"./cont4_bg3.png": 6173,
	"./cont5_icon.png": 377,
	"./cont5_img1.png": 6702,
	"./cont5_img2.png": 4027,
	"./dbcwallet.png": 1546,
	"./decentral_gpt.png": 7015,
	"./deeplink.png": 5584,
	"./drcpad.png": 4815,
	"./gate.png": 1621,
	"./glow.png": 5362,
	"./good.png": 5365,
	"./haibao.png": 4695,
	"./haibaocloud.png": 2926,
	"./haibaocloud1.png": 2187,
	"./huobi.png": 3449,
	"./hycons-img.png": 4597,
	"./hycons.png": 3440,
	"./line.png": 4210,
	"./mexc.svg": 2168,
	"./new1.jpg": 4738,
	"./new10.webp": 8288,
	"./new2.jpg": 9082,
	"./new3.png": 2519,
	"./new4.jpg": 2136,
	"./new5.jpg": 1998,
	"./new5.webp": 4372,
	"./new6.png": 5595,
	"./new7.jpg": 4708,
	"./new8.jpg": 7953,
	"./new9.avif": 9070,
	"./pancakeswap.png": 8542,
	"./partner1.png": 9014,
	"./partner2.png": 7592,
	"./partner3.png": 8020,
	"./partner4.png": 237,
	"./partner5.png": 4714,
	"./partner6.png": 4152,
	"./partner7.png": 6170,
	"./subscan.webp": 4903,
	"./superimage.webp": 2918,
	"./swft.png": 2964,
	"./tikeren.jpg": 6829,
	"./uniswap.png": 8294
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;